module.exports = __webpack_public_path__ + "img/kefu-bg.cfa18845.png";